import { Component, input } from '@angular/core';
import { BaseIconComponent } from './base-icon.component';

/**
 * Add-task "assignees" metadata icon — a person glyph on a rounded
 * `#F9FAFB` tile, used as the assignee picker trigger in the Board add-task
 * creator. The glyph inherits `color()` via `currentColor`; the tile fill is
 * fixed.
 */
@Component({
  selector: 'lib-add-task-assignees-icon',
  standalone: true,
  template: `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      [attr.width]="width()"
      [attr.height]="height()"
      [attr.viewBox]="viewBox()"
      fill="none"
      [style.color]="active() ? '#2970ff' : color()"
      [class]="iconClass()">
      <path
        d="M0 4C0 1.79086 1.79086 0 4 0H20C22.2091 0 24 1.79086 24 4V20C24 22.2091 22.2091 24 20 24H4C1.79086 24 0 22.2091 0 20V4Z"
        [attr.fill]="active() ? '#eff6ff' : '#F9FAFB'" />
      <path
        d="M14.0004 19.1659H10.0004C9.12042 19.1659 8.38709 19.0792 7.76709 18.8925C7.54042 18.8259 7.39376 18.6059 7.40709 18.3725C7.57376 16.3792 9.59376 14.8125 12.0004 14.8125C14.4071 14.8125 16.4204 16.3725 16.5938 18.3725C16.6138 18.6125 16.4671 18.8259 16.2338 18.8925C15.6138 19.0792 14.8804 19.1659 14.0004 19.1659ZM8.48042 18.0392C8.92042 18.1259 9.42042 18.1659 10.0004 18.1659H14.0004C14.5804 18.1659 15.0804 18.1259 15.5204 18.0392C15.1671 16.7592 13.7071 15.8125 12.0004 15.8125C10.2938 15.8125 8.83376 16.7592 8.48042 18.0392Z"
        fill="currentColor" />
      <path
        d="M13.9997 5.33398H9.99967C6.66634 5.33398 5.33301 6.66732 5.33301 10.0007V14.0007C5.33301 16.5207 6.09301 17.9006 7.90634 18.414C8.05301 16.6806 9.83301 15.314 11.9997 15.314C14.1663 15.314 15.9463 16.6806 16.093 18.414C17.9063 17.9006 18.6663 16.5207 18.6663 14.0007V10.0007C18.6663 6.66732 17.333 5.33398 13.9997 5.33398ZM11.9997 13.4473C10.6797 13.4473 9.61301 12.374 9.61301 11.054C9.61301 9.734 10.6797 8.66732 11.9997 8.66732C13.3197 8.66732 14.3863 9.734 14.3863 11.054C14.3863 12.374 13.3197 13.4473 11.9997 13.4473Z"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round" />
      <path
        d="M11.9999 13.946C10.4066 13.946 9.11328 12.646 9.11328 11.0527C9.11328 9.45936 10.4066 8.16602 11.9999 8.16602C13.5933 8.16602 14.8866 9.45936 14.8866 11.0527C14.8866 12.646 13.5933 13.946 11.9999 13.946ZM11.9999 9.16602C10.9599 9.16602 10.1133 10.0127 10.1133 11.0527C10.1133 12.0994 10.9599 12.946 11.9999 12.946C13.0399 12.946 13.8866 12.0994 13.8866 11.0527C13.8866 10.0127 13.0399 9.16602 11.9999 9.16602Z"
        fill="currentColor" />
    </svg>
  `,
})
export class AddTaskAssigneesIconComponent extends BaseIconComponent {
  override width = input<string>('24');
  override height = input<string>('24');
  override viewBox = input<string>('0 0 24 24');
  override color = input<string>('#6B7280');
  /** Active (picker open) state: primary-faint tile + primary glyph. */
  readonly active = input<boolean>(false);
}
